<template>
  <div>
    <el-dialog :title="applyPlanData.title" :visible.sync="applyPlanData.show" center width="400px">
      <el-table :data="tableData" style="width: 100%" border :cell-style="{ padding: '1' }">
        <el-table-column align="center" label="套用选择" width="100px">
          <template slot-scope="scope">
            <el-checkbox @change="changePlan(scope.row.checked,scope.$index)" v-model="scope.row.checked"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="Name" :label="$t('Proposal')"></el-table-column>
        <!-- <el-table-column align="center" prop="UserId" :label="$t('Amount')"></el-table-column>
        <el-table-column align="center" prop="TgName" label="连赢"></el-table-column>
        <el-table-column align="center" prop="降赔" :label="$t('ReductionCompensation')"></el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitEditRow">{{$t('Confirm2')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  props: {
    applyPlanData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      const data = {
        SellerId: this.filters.SellerId,
      };
      let url =
        this.applyPlanData.type == 1
          ? "/game/get_jiangpei_templete"
          : "/game/get_peilv_templete";
      app.post(url, data, (res) => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.tableData.forEach((item) => {
            item.checked = false;
          });
        }
      });
    },
    changePlan(val, index) {
      this.tableData.forEach((item, index1) => {
        if (index1 != index) item.checked = false;
      });
      this.$forceUpdate();
    },
    submitEditRow() {
      let id = this.tableData.find((item) => item.checked)?.Id;
      if (!id) return this.$message.warning("请选择套用方案");
      this.$emit("submitApplyPlanData", id);
    },
  },
};
</script>
  
  <style  scoped>
</style>